export const DisableUI = (selectionArray) =>{
    let n = document.getElementsByClassName("action-tab");

    for (let i = 0; i < n.length; i++) {
        // let text = n[i].textContent.trim();
        // if (selectionArray.includes(text)) {
        //     // Replace 'chat-label' with 'chat-label-select'
        //     n[i].classList.remove("chat-label");
        //     n[i].classList.add("chat-label-select");
        //   }
      n[i].disabled = true;
      n[i].style.cursor = "not-allowed";
      // n[i].style.opacity = 0.5;
      n[i].style.pointerEvents = "none";
    }

    let inputs = document.getElementsByClassName("form-control");

    for (let i = 0; i < inputs?.length; i++) {
      inputs[i].style.cursor = "not-allowed"; // Set cursor style
      inputs[i].disabled = true; // Disable input elements
      // Optional styles if needed:
      // elements[i].style.opacity = "0.5";
      // elements[i].style.pointerEvents = "none";
    }

    let  dropdown = document.getElementsByClassName("dropdown-container");

    for (let i = 0; i < dropdown?.length; i++) {
      dropdown[i].style.cursor = "not-allowed"; // Set cursor style
      dropdown[i].disabled = true; // Disable input elements
      // Optional styles if needed:
      // dropdown[i].style.opacity = "0.5";
      dropdown[i].style.pointerEvents = "none";
    }

    let button = document.getElementsByClassName("action-button");

    for (let i = 0; i < button?.length; i++) {
      let btn = button[i];
      let computedColor = window.getComputedStyle(btn).color;
    
      if (computedColor !== "rgb(142, 129, 161)") {
        btn.style.color = "rgba(142, 129, 161, 1)";
      }
    
      btn.style.border = "1px solid rgba(142, 129, 161, 1)";
      
      if (!btn.classList.contains("selected")) {
        btn.style.backgroundColor = "transparent";
      }
    }
    

    let submitButton = document.getElementsByClassName("submit-button-action");

    for (let i = 0; i < submitButton?.length; i++) {
      let computedColor = window.getComputedStyle(submitButton[i]).color; // Get the computed color
      if(computedColor != "rgb(142, 129, 161)"){
        submitButton[i].style.color = "rgba(142, 129, 161, 1)"; // Set cursor style
      }
      submitButton[i].style.border = '1px solid rgba(142, 129, 161, 1)'; // Disable input elements
    }

    const buttons = document.querySelectorAll(".disable-tooltips");

    buttons.forEach(btn => {
      if (btn.classList.contains("disable-tooltips")) {
        btn.style.cursor = "not-allowed"; // Set cursor style
        btn.style.disabled = true; // Disable input elements
        btn.style.pointerEvents = "none";
        btn.classList.add("no-tooltip");
      }
    }); 
   
}

export const getDelayInMs = (timeStr) => {
  if (!timeStr) return 0;

  const match = timeStr.match(/^(\d+)(s|m)$/);
  if (!match) return 0;

  const value = parseInt(match[1], 10);
  const unit = match[2];

  if (unit === "s") return value * 1000;
  if (unit === "m") return value * 60 * 1000;

  return 0;
};
